function wu_giving_select() {

	$('#giving_options').on('change', function(){
		var selected 	= $(this).find(":selected"),
			formID 		= selected.attr('value'),
			title 		= selected.attr('name'),
			desc 		= selected.data('desc');

		//Empty the form
		$('#bbox-root').empty().show();

		//Dump in the title and desc
		$('.giving__title').html(title);
		$('.giving__desc').html(desc);

		//Trigger the form with new ID
        bbox.showForm(formID);


	});

}

wu_giving_select();

$(document).on("click", "body.giving .giving-panel-toggle", function (t) {
  t.preventDefault(), $("#bbox-root").remove(), console.log("clicker");
  var e = $(this).attr("data-form-id"),
    i = $(this).parents(".panel"),
    o = i.find(".panel-collapse"),
    s = o.offset().top - $(window).height() / 4;
  console.log(e),
    o.append('<div id="bbox-root"></div>'),
    $("body, html").animate({ scrollTop: s + "px" }),
    setTimeout(function () {
      bbox.showForm(e);
    }, 500);
});
